import Landing from "./components/landing";

const Routes = () => <Landing />;

export default Routes;
